import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";
import api, { formatError } from "@/lib/api";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [email, setEmail] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 6) return setError("The password must have at least 6 characters / Au moins 6 caractères.");
    if (pw !== pw2) return setError("The two passwords don't match / Les deux mots de passe sont différents.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password: pw });
      setEmail(data.email);
    } catch (err) { setError(formatError(err?.response?.data?.detail)); } finally { setBusy(false); }
  };

  const input = "w-full h-12 rounded-xl border-2 border-slate-200 focus:border-blue-500 outline-none px-4";
  return (
    <div className="min-h-screen bg-[#EAF7F4] font-parent text-slate-900 flex items-center justify-center p-5" data-testid="set-password-page">
      <div className="w-full max-w-sm nb-card bg-white p-7">
        {email ? (
          <div className="text-center" data-testid="set-password-done">
            <CheckCircle2 className="mx-auto text-emerald-500 mb-3" size={44} />
            <h1 className="text-2xl font-bold">Password saved!</h1>
            <p className="text-sm text-slate-500 mt-2">Mot de passe enregistré. Log in with <b>{email}</b>.</p>
            <Link to="/login" className="mt-5 inline-block rounded-full bg-blue-600 text-white font-semibold px-6 py-2.5" data-testid="set-password-login">Log in / Se connecter</Link>
          </div>
        ) : !token ? (
          <p className="text-center text-slate-600" data-testid="set-password-invalid">This link is not valid. / Ce lien n'est pas valide. <Link to="/forgot-password" className="underline text-blue-600" data-testid="set-password-invalid-new-link">Get a new link / Recevoir un nouveau lien</Link></p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div className="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center mb-2"><KeyRound size={22} /></div>
            <h1 className="text-2xl font-bold">Choose your password</h1>
            <p className="text-sm text-slate-500 -mt-1">Choisissez votre mot de passe</p>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password / Nouveau mot de passe" className={input} data-testid="set-password-input" autoFocus />
            <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Type it again / Confirmer" className={input} data-testid="set-password-confirm" />
            {error && <p className="text-sm text-red-600 font-medium" data-testid="set-password-error">{error} <Link to="/forgot-password" className="underline text-blue-600" data-testid="set-password-new-link">Get a new link / Recevoir un nouveau lien</Link></p>}
            <button disabled={busy} data-testid="set-password-submit" className="w-full h-12 rounded-full bg-blue-600 hover:bg-blue-700 text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60">
              {busy && <Loader2 size={18} className="animate-spin" />} Save / Enregistrer
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
